"use strict";

require("cross-fetch/polyfill");

var _publications = _interopRequireDefault(require("./publications"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _publications.default;